
















import { Component, Prop, Vue } from "vue-property-decorator";
import { Post } from "@/components/data-types/Post";
import AuthorIcon from "@/components/AuthorIcon.vue";

@Component({
  components: {
    AuthorIcon
  }
})
export default class MainPost extends Vue {
  @Prop() private post!: Post;
  formatedDate(): string {
    const date: Date = new Date(this.post.date);
    if (date === null) {
      return "";
    }
    return date.toLocaleDateString() + " " + date.toLocaleTimeString();
  }
}
